import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-start flex-column" }
const _hoisted_3 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_4 = { class: "card-body py-3" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light" }, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Country"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1)
const _hoisted_8 = {
  class: "sortable-icon",
  scope: "row"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.pageName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _hoisted_7,
          (_ctx.getDynamicList)
            ? (_openBlock(), _createBlock(_component_draggable, _mergeProps({
                key: 0,
                modelValue: _ctx.getDynamicList,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.getDynamicList) = $event)),
                tag: "tbody",
                type: "transition-group",
                "item-key": "id",
                name: "flip-list"
              }, _ctx.dragOptions), {
                item: _withCtx(({ element }) => [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_8, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/abstract/abs015.svg" })
                    ]),
                    _createElementVNode("td", null, _toDisplayString(element.name), 1),
                    _createElementVNode("td", null, _toDisplayString(element.country.name), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                        onClick: ($event: any) => (_ctx.moveItemToTop(element)),
                        title: "Move to top"
                      }, [
                        _createElementVNode("span", _hoisted_10, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr003.svg" })
                        ])
                      ], 8, _hoisted_9)
                    ])
                  ])
                ]),
                _: 1
              }, 16, ["modelValue"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}